import { dispatch } from 'old/store';

// TODO rewrite this to react query and remove this hook
export const useOnCreateObject = () => {
  return async (draft: any) => {
    if (draft.questions) {
      return dispatch.feed.createPoll({ poll: draft });
    }

    if (draft.kudos) {
      return dispatch.feed.createKudos({
        kudo: {
          ...draft.kudos,
          attachments: draft.attachments,
          post_in_communities: draft.post_in_communities,
          pinned: draft.pinned,
          publish_at: draft.publish_at,
          text_content: draft.text_content,
          html_content: draft.html_content,
        },
      });
    }

    return dispatch.feed.createAsync({ draft, parent_id: null });
  };
};
